// extracted by mini-css-extract-plugin
module.exports = {"container":"CourseNotFinished_container__2rw6L","msg":"CourseNotFinished_msg__27LzL","continueBtn":"CourseNotFinished_continueBtn__3CGbH"};